import React, { Component } from 'react';
import Echarts from "echarts";

class Revenue extends Component {

    componentDidMount() {
        const data = this.props.data.GOP || {};
        const dataX = Object.entries(data).map(x => (x[0] + '月'));
        const dataY = Object.entries(data).map(x => (Number(x[1])));

        this.setChart(dataX, dataY);
        window.addEventListener('resize', () => {
            this.setChart(dataX, dataY, true, true);
        });
    }

    componentWillReceiveProps(nextProps) {
        const data = nextProps.data.GOP || {};
        const dataX = Object.entries(data).map(x => (x[0] + '月'));
        const dataY = Object.entries(data).map(x => (Number(x[1])));

        this.setChart(dataX, dataY, true);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => { });
    }

    setChart = (dataX, dataY, update, isOnResize) => {
        var myChart = Echarts.init(document.getElementById('Revenue'));
        myChart.resize();
        if (isOnResize) {
            return
        }
        if (update) {
            myChart.setOption({
                xAxis: [{
                    data: dataX
                }],
                series: [{
                    data: dataY
                }]
            });
            return
        }

        const option = {
            // title: {
            //     text: "Total Revenue",
            //     subtext: '',
            //     x: 'left'
            // },
            legend: {
                data: ['Food and Beverage Bevenue'],
                align: 'left',
                textStyle: {
                    color: 'rgba(102, 102, 102, 1)',
                    padding: [0, 0, 0, 16]
                }
            },
            color: ['rgba(50, 122, 183, 1)'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: [],
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: 'Food and Beverage Bevenue',
                    type: 'bar',
                    barWidth: '50%',
                    data: []
                }
            ]
        }
        myChart.setOption(option);
    }

    render() {
        return (
            <div>
                <div className="total_style">本年损益分析 毛利润</div>
                <div id="Revenue" style={{ height: 400, width: '100%' }} />
            </div>
        );
    }
}

export default Revenue;


// WEBPACK FOOTER //
// ./src/components/BI/home/Revenue.js